import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Chunk } from '../../chunk.dto';
import { ChunkService } from '../../chunk.service';

@Component({
  selector: 'app-fix-creation-option',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <div class="interactive-item" (click)="onClick()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">build</mat-icon>
        <span class="interactive-item__text">{{ 'ChunkDisplayer.chunkOptions.FixChunkCreation' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FixCreationOptionComponent {
  @Input() chunk: Chunk;
  @Output() actionTriggered = new EventEmitter<void>();

  private chunkService = inject(ChunkService);

  onClick(): void {
    this.chunkService.restartChunkCreationProcess(this.chunk);
    this.actionTriggered.emit();
  }
}
